module.exports = __webpack_public_path__ + "img/duck.9d0e9f6.png";